import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import Authentication from "../../authentication";
import Shards from "../../authentication/shards";
import Timeout from "../../common/timeout";
import RootView from "../../views/layout";
import StatusBar from "../../views/status";
import Router from "../../router";
import { config, initialRoutes, routerOptions } from "../../config/router";
import UserProfile from "../../common/user-profile";
import ReportingPreferences from "../../common/reporting-preferences";
import ReportingHistory from "../../common/reporting-history";
import DataTableEvents from "../../common/datatable-events";
import FileExporter from "../../utils/file-exporter";
import HealthcheckView from "../../views/healthcheck";

const globalChannel = Radio.channel("global");
const reportChannel = Radio.channel("report");

class Application extends Marionette.Application {
  regions() {
    return {
      container: "body",
    };
  }

  initialize() {
    // console.group("Application")
    // console.log("initialize")
    // console.time("app-start")

    this.user = null;

    // setup listeners
    this.listenTo(globalChannel, "router:ready", this._onRouterReady);
    this.listenTo(globalChannel, "auth-user-set", this._onAuthUserSet);
    this.listenTo(globalChannel, "shard-set", this._onShardSet);
    this.listenTo(
      globalChannel,
      "user-profile-loaded",
      this._onUserProfileReady
    );
    this.listenTo(
      reportChannel,
      "reporting-preferences-loaded",
      this._onReportingPreferencesReady
    );
    this.listenTo(globalChannel, "layout-ready", this._onLayoutReady);
  }

  // receives options passed to start()
  onBeforeStart(options) {
    // console.log("onBeforeStart")

    new Timeout();

    return options;
  }

  // receives options passed to start()
  onStart(options) {
    // console.log("onStart")

    new StatusBar();
    new Authentication();

    return options;
  }

  _onAuthUserSet(user) {
    // console.log("_onAuthUserSet");
    this.user = user;

    new Shards();
  }

  _onShardSet() {
    // console.log("_onShardSet")

    const options = Object.assign({}, config, {
      initialRoutes,
      routerOptions,
    });
    new Router(options);
  }

  _onRouterReady() {
    // console.log("_onRouterReady")

    // load user profile
    new UserProfile();

    // utils
    new ReportingHistory();
    new DataTableEvents();
  }

  _onUserProfileReady() {
    // console.log("_onUserProfileReady")

    // load user preferences
    new ReportingPreferences();
  }

  _onReportingPreferencesReady() {
    // console.log("_onReportingPreferencesReady")

    // render main region
    this.container.show(new RootView());
  }

  _onLayoutReady() {
    // console.log("_onLayoutReady")

    new FileExporter();
    new HealthcheckView();

    // console.timeEnd("app-start")
    // console.groupEnd()
  }
}

export { Application as default };
